<template>
	<TriggerForm :formItems="formItems" />
</template>

<script>
import WorkflowToolService from '@/utils/workflow-tool-service';
import FormItem from './FormItem.vue';
import TriggerForm from './TriggerForm.vue';

export default {
	name: 'ToolTriggerFormDataProvider',
	props: { workflow: { type: Object } },
	components: { TriggerForm },
	computed: {
		formItems() {
			return [
				{
					component: FormItem,
					listeners: {},
					props: { item: { title: 'Feature Type', value: WorkflowToolService.getFeatureTitle(this.workflow) } },
				},
				{
					component: FormItem,
					listeners: {},
					props: { item: { title: 'Tool placement', value: WorkflowToolService.getToolPlacementTitle(this.workflow) } },
				},
			];
		},
	},
};
</script>

<style lang="scss" scoped></style>
